import {SiteEntity} from "../../commons/models/siteEntity.model";
import {AccountModel} from "../../account/angular/models/account.model";
import {AgentModel} from "../../agents/angular/models/agent.model";


export enum SchedulingProjectProviderType {
  VisitCall= 'VisitCall',
  System = 'System',
  None = 'None'
}

export enum SchedulingProjectVisitCallProviderType {
  VisitCall= 'VisitCall',
  None = 'None'
}

/**
 * Whether a visit plan created from the template pulls its accounts from the plan's branch on
 * creation (System) or opens empty, to be filled by a CSV import later (None).
 */
export enum VisitPlanAccountImportMode {
  System = 'System',
  None = 'None'
}

/** The same choice for the plan's agents. */
export enum VisitPlanAgentImportMode {
  System = 'System',
  None = 'None'
}


export interface DeliveryDaysValidateError {
  rowNumber: number;
  description: string;
  type: string;
}

export interface DeliveryDaysEntityValue {
  value: boolean | number | Date;
  state: string;
  source: string;
}

export interface DeliveryDaysEntity {
  accountId: string;
  deliveryDetailsByDate: {
    [date: string]: {
      isDeliveryDay: DeliveryDaysEntityValue;
      deliveryFrom: DeliveryDaysEntityValue;
    }
  }
}

export interface DeliveryDaysValidateRowModel {
  rowNumber: number;
  entity: DeliveryDaysEntity;
  mappingErrors: DeliveryDaysValidateError[];
}

export interface MetadataMap {
  visitPlanId: string;
  trackingId: string;
}

export interface ProcessDetails {
  id: string;
  progress: number;
  completed: number;
  started: number;
  failed: number;
  total: number;
  timedOut: number;
  status: string;
}

export interface DeliveryTask {
  id: string;
  type: string;
  metadataMap: MetadataMap;
  status: string;
}

export interface ImportVisitPlanResponseModel extends SiteEntity {
  id: string;
  metadataMap: { [key: string]: string; };
  details: ProcessDetails;
  tasks: DeliveryTask[];
}

export interface VisitPlanImportMappingError {
  fieldName?: string;
  description?: string;
  type?: string;
}

export interface AccountsImportValidateRowModel {
  rowNumber: number;
  entity: AccountModel | null;
  mappingErrors: VisitPlanImportMappingError[];
}

export interface AccountsImportBatchDetailsModel {
  status: string;
  total: number;
  started: number;
  completed: number;
  failed: number;
}

export interface AccountsImportBatchModel {
  id?: string;
  processTrackingId?: string;
  details?: AccountsImportBatchDetailsModel;
}

export enum AgentsImportBatchStatusEnum {
  Started = 'Started',
  Processing = 'Processing',
  Completed = 'Completed',
  CompletedWithErrors = 'CompletedWithErrors'
}

export interface AgentsImportValidateRowModel {
  rowNumber: number;
  entity: AgentModel | null;
  mappingErrors: VisitPlanImportMappingError[];
}

export interface AgentsImportBatchDetailsModel {
  status?: string;
  total?: number;
  started?: number;
  completed?: number;
  failed?: number;
  progress?: number;
}

export interface AgentsImportBatchModel {
  id?: string;
  siteId?: string;
  batchType?: string;
  details?: AgentsImportBatchDetailsModel;
}

export interface AgentsImportStatusTotalsModel {
  total?: number;
  started?: number;
  completed?: number;
  failed?: number;
  timeOut?: number;
}

export interface AgentsImportStatusModel {
  batch?: AgentsImportBatchModel;
  totals?: AgentsImportStatusTotalsModel;
}
